import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import { FontFamily } from '@zocdoc/components/src/typography';

const fontCss = css`
    font: 15px/24px ${FontFamily.SharpSansBold};
`;

const CoercedH4 = styled.h4`
    ${fontCss}
    margin-top: 2.5em;
`;

const headerCss = css`
    ${fontCss}
    margin-top: 4px;
`;

const NormalH4 = styled.h4`${headerCss}`;
const NormalH5 = styled.h5`${headerCss}`;
const NormalH6 = styled.h6`${headerCss}`;

export default class Header4Renderer extends React.Component {
    static propTypes = {
        level: PropTypes.number,
        children: PropTypes.array,
    }

    render() {
        switch (this.props.level) {
            case 1:
            case 2:
            case 3:
                return (
                    <CoercedH4>
                        {this.props.children}
                    </CoercedH4>
                );

            case 4:
                return (
                    <NormalH4>
                        {this.props.children}
                    </NormalH4>
                );

            case 5:
                return (
                    <NormalH5>
                        {this.props.children}
                    </NormalH5>
                );

            default:
                return (
                    <NormalH6>
                        {this.props.children}
                    </NormalH6>
                );
        }
    }
}
